import { render, staticRenderFns } from "./AttachmentTypeList.vue?vue&type=template&id=6eac88ff&"
import script from "./AttachmentTypeList.vue?vue&type=script&lang=js&"
export * from "./AttachmentTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports